import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { NavigationProgress } from "@/components/layout/PageTransition";

export function DashboardShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen">
      <NavigationProgress />
      <Sidebar />
      <div className="lg:pl-[calc(var(--sidebar-width)+2rem)]">
        <Header />
        <main className="mx-auto w-full max-w-[var(--content-max-width)] px-8 py-10 lg:px-12">
          {children}
        </main>
      </div>
    </div>
  );
}
